import { Loader, Stack, Text, Title } from "@mantine/core";
import { useNavigate } from "react-router";
import { SiteName } from "../../utils/enums";
import { AnchorLink } from "../AnchorLink/AnchorLink";
import { PublicLayout } from "../Layout/PublicLayout";

declare const SITE_NAME: SiteName;

function PrivacyStatement() {
  const navigate = useNavigate();

  if (SITE_NAME === SiteName.Alva) {
    navigate("https://www.alva-energie.de/datenschutz");
  } else if (SITE_NAME === SiteName.Wavelr || SITE_NAME === SiteName.Optinode) {
    navigate("https://www.node.energy/legal/avv");
  }

  return (
    <PublicLayout>
      <div style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem" }}>
        {SITE_NAME === SiteName.Smarendo && <SmarendoPrivacyStatement />}
        {SITE_NAME !== SiteName.Smarendo && (
          <Stack align="center" gap={0}>
            <Loader />
            <Text mt="lg">Wird geladen...</Text>
          </Stack>
        )}
      </div>
    </PublicLayout>
  );
}

function SmarendoPrivacyStatement() {
  return (
    <>
      <Title order={2}>
        Datenschutzerklärung im Zusammenhang mit der Registrierung und Nutzung
        des Portals Smarendo
      </Title>
      <p>
        Rödl IT-Consulting GmbH (nachfolgend als „Rödl & Partner“,
        „Verantwortlicher“, „wir“ oder „uns“ bezeichnet) informiert Sie hiermit
        über die Verarbeitung Ihren personenbezogenen Daten im Zusammenhang mit
        der Registrierung und Nutzung des Energieportals „Smarendo“ (nachfolgend
        als „Portal“ bezeichnet) und Ihre diesbezüglichen Rechte.
      </p>
      <br />
      <h4>Name und Kontaktdaten des Verantwortlichen</h4>
      <p>
        Verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten sind
      </p>

      <p>
        Rödl IT-Consulting GmbH
        <br />
        Äußere Sulzbacher Straße&nbsp;100
        <br />
        90491&nbsp;Nürnberg
        <br />
        Tel.: +49&nbsp;911&nbsp;91&nbsp;93&nbsp;0
        <br />
        Fax: +49&nbsp;911&nbsp;91&nbsp;93&nbsp;1900
        <br />
        E-Mail:{" "}
        <AnchorLink href="mailto:info@roedl.de" target="_self">
          info@roedl.de
        </AnchorLink>
      </p>

      <p>und</p>

      <p>
        Rödl GmbH Rechtsanwaltsgesellschaft Steuerberatungsgesellschaft
        Wirtschaftsprüfungsgesellschaft
        <br />
        Äußere Sulzbacher Straße&nbsp;100
        <br />
        90491&nbsp;Nürnberg
        <br />
        Tel.: +49&nbsp;911&nbsp;91&nbsp;93&nbsp;0
        <br />
        Fax: +49&nbsp;911&nbsp;91&nbsp;93&nbsp;1900
        <br />
        E-Mail:{" "}
        <AnchorLink href="mailto:info@roedl.de" target="_self">
          info@roedl.de
        </AnchorLink>
        .
      </p>
      <br />
      <h4>Kontaktdaten des Datenschutzbeauftragten</h4>
      <p>
        Postalisch können Sie unseren Datenschutzbeauftragten unter dieser
        Adresse erreichen:
      </p>

      <p>
        Vertraulich
        <br />
        Zu Händen des Datenschutzbeauftragten
        <br />
        Rödl & Partner
        <br />
        Äußere Sulzbacher Straße&nbsp;100
        <br />
        90491&nbsp;Nürnberg
      </p>

      <p>
        Per E-Mail erreichen Sie den Datenschutzbeauftragten unter
        <AnchorLink href="mailto:dsb@roedl.com" target="_self">
          dsb@roedl.com
        </AnchorLink>
        .
      </p>
      <br />
      <h4>Zweck und Rechtsgrundlage der Verarbeitung</h4>
      <ol>
        <li>
          <p>
            Wenn Sie sich für unser Portal registrieren und dieses nutzen,
            verarbeiten wir Ihre personenbezogenen Daten, die Sie bei der
            Registrierung angegeben und diese an uns übermittelt haben.
          </p>

          <p>
            Rechtsgrundlage für die Verarbeitung Ihrer personenbezogenen Daten
            zu diesem Zweck ist der mit Ihnen abgeschlossene Vertrag
            (Art.&nbsp;6&nbsp;Abs.&nbsp;1&nbsp;S.&nbsp;1&nbsp;lit.&nbsp;b&nbsp;DSGVO).
          </p>
        </li>

        <li>
          <p>
            Wir und die Rödl GmbH Rechtsanwaltsgesellschaft
            Steuerberatungsgesellschaft Wirtschaftsprüfungsgesellschaft, Äußere
            Sulzbacher Straße&nbsp;100, 90491&nbsp;Nürnberg, Tel.:
            +49&nbsp;911&nbsp;91&nbsp;93&nbsp;0, E-Mail:
            <AnchorLink href="mailto:info@roedl.de" target="_self">
              info@roedl.de
            </AnchorLink>
            , beide als Unternehmen der Rödl & Partner Unternehmensgruppe,
            können die von Ihnen angegebenen personenbezogenen Daten
            (insbesondere Name und Anschrift) zudem verarbeiten, um Sie per Post
            über Entwicklungen aus den Bereichen Recht, Steuern und Wirtschaft
            zu informieren sowie Ihnen sonstige interessante und wichtige
            Informationen zur Verfügung zu stellen. Die Verarbeitung Ihrer
            personenbezogenen Daten zu diesem Zweck erfolgt auf der Grundlage
            eines berechtigten Interesses von Rödl & Partner im Sinne des
            Art.&nbsp;6&nbsp;Abs.&nbsp;1&nbsp;S.&nbsp;1&nbsp;lit.&nbsp;f&nbsp;DSGVO.
            Es besteht ein berechtigtes wirtschaftliches Interesse,
            Interessenten, Kunden und Mandanten von Rödl & Partner über weitere
            eigene Angebote und Veranstaltungen zu informieren, um eine
            langfristige Kundenbeziehung aufzubauen und aufrechtzuerhalten.
          </p>

          <p>
            Sie können durch eine Nachricht an unsere oben angegebene
            Kontaktadresse jederzeit Widerspruch nach Art.&nbsp;21&nbsp;DSGVO
            gegen die Verwendung Ihrer Daten für Marketingzwecke einlegen. Die
            Verarbeitung Ihrer personenbezogenen Daten wird dann eingestellt, es
            sei denn, es liegen zwingende schutzwürdige Gründe für die
            Verarbeitung vor, die Ihre Interessen, Rechte und Freiheiten
            überwiegen, oder wenn die Verarbeitung der Geltendmachung, Ausübung
            oder Verteidigung von Rechtsansprüchen dient.
          </p>
        </li>

        <li>
          <p>
            Wir und die Rödl GmbH Rechtsanwaltsgesellschaft
            Steuerberatungsgesellschaft Wirtschaftsprüfungsgesellschaft können
            Ihre personenbezogenen Daten (insbesondere E-Mail-Adresse) darüber
            hinaus verwenden, um Ihnen per E-Mail Informationen über
            Entwicklungen aus den Bereichen Recht, Steuern und Wirtschaft sowie
            zu weiteren Angeboten und Veranstaltungen (insbesondere Webinare)
            zukommen zu lassen. Rechtsgrundlage hierfür ist
            §&nbsp;7&nbsp;Abs.&nbsp;3&nbsp;UWG&nbsp;i.&nbsp;V.&nbsp;m. dem mit
            Ihnen abgeschlossenen Vertrag
            (Art.&nbsp;6&nbsp;Abs.&nbsp;1&nbsp;S.&nbsp;1&nbsp;lit.&nbsp;b&nbsp;DSGVO)
            bzw. Ihre Einwilligung
            (Art.&nbsp;6&nbsp;Abs.&nbsp;1&nbsp;S.&nbsp;1&nbsp;lit.&nbsp;a&nbsp;DSGVO).
          </p>

          <p>
            Betroffene können der Verwendung der E-Mail-Adresse jederzeit
            widersprechen, ohne dass hierfür Kosten entstehen
            (§&nbsp;7&nbsp;Abs.&nbsp;4&nbsp;Nr.&nbsp;4&nbsp;UWG).
          </p>

          <p>
            Falls die Verarbeitung Ihrer personenbezogenen Daten zu diesem Zweck
            auf Basis Ihrer Einwilligung erfolgt, können Sie diese jederzeit mit
            Wirkung für die Zukunft widerrufen, wobei der Widerruf ebenso
            einfach zu erklären ist, wie die Einwilligung selbst. Durch den
            Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der
            Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.
            Den Widerruf können Sie per E-Mail an{" "}
            <AnchorLink href="mailto:dsb@roedl.com" target="_self">
              dsb@roedl.com
            </AnchorLink>{" "}
            oder durch eine Nachricht an die oben angegebene Kontaktadresse
            erklären.
          </p>
        </li>

        <li>
          <p>
            Weiterhin können wir personenbezogene Daten (insbesondere
            IP-Adressen) von Ihnen verarbeiten, sofern dies zur Gewährleistung
            der IT-Sicherheit und des IT-Betriebs, zur Erfüllung rechtlicher
            Verpflichtungen und zur Abwehr von geltend gemachten
            Rechtsansprüchen gegen uns erforderlich ist. Die Rechtmäßigkeit der
            Verarbeitung ergibt sich aus
            Art.&nbsp;6&nbsp;Abs.&nbsp;1&nbsp;S.&nbsp;1&nbsp;lit.&nbsp;f&nbsp;DSGVO.
          </p>
        </li>
      </ol>
      <br />
      <h4>Weitergabe und Übertragung von Daten</h4>
      <p>
        Eine Weitergabe Ihrer personenbezogenen Daten ohne Ihre ausdrückliche
        vorherige Einwilligung erfolgt neben den explizit in dieser
        Datenschutzerklärung genannten Fällen lediglich dann, wenn es gesetzlich
        zulässig bzw. erforderlich ist.
      </p>

      <p>
        Soweit erforderlich, werden Ihre personenbezogenen Daten, die Sie uns im
        Rahmen der Registrierung und Nutzung des Portals mitteilen, innerhalb
        der Rödl & Partner Unternehmensgruppe oder an externe Dienstleister
        (etwa zum Betrieb des Portals) weitergeben. Soweit wir für die
        Erbringung unserer Leistungen externe Dienstleister einsetzen, ist eine
        etwaige Weitergabe personenbezogener Daten dadurch gerechtfertigt, dass
        wir unsere Fremdunternehmen und externen Dienstleister entweder im
        Rahmen von Art.&nbsp;28&nbsp;Abs.&nbsp;1&nbsp;DSGVO als
        Auftragsverarbeiter sorgfältig ausgewählt, regelmäßig überprüft und
        vertraglich verpflichtet haben, sämtliche personenbezogenen Daten
        ausschließlich entsprechend unserer Weisungen zu verarbeiten oder im
        Rahmen von Art.&nbsp;26&nbsp;Abs.&nbsp;1&nbsp;DSGVO als gemeinsam
        Verantwortliche Zwecke und Mittel der Verarbeitung gemeinsam festgelegt
        haben.
      </p>
      <br />
      <h4>Datenübermittlung in Drittländer</h4>
      <p>
        Ihre personenbezogenen Daten werden nicht in Länder außerhalb der EU
        übermittelt oder dort verarbeitet.
      </p>
      <br />
      <h4>Datenspeicherung</h4>
      <p>
        Die vom Verantwortlichen verarbeiteten Daten werden nach Maßgabe der
        Art.&nbsp;17&nbsp;und&nbsp;18&nbsp;DSGVO gelöscht oder in ihrer
        Verarbeitung eingeschränkt. Die bei uns gespeicherten Daten werden
        gelöscht, sobald sie für Ihre oben benannte Zweckbestimmung nicht mehr
        erforderlich sind und der Löschung keine gesetzlichen
        Aufbewahrungsfristen entgegenstehen, spätestens 10 Jahre nach Beendigung
        der Zusammenarbeit.
      </p>

      <p>
        Für den Fall, dass Sie einer längeren Speicherung Ihrer
        personenbezogenen Daten zugestimmt haben, speichern wir diese nach
        Maßgabe Ihrer Einwilligungserklärung.
      </p>
      <br />
      <h4>Betroffenenrechte</h4>
      <p>
        Zur Ausübung der nachfolgend aufgeführten Rechte wenden Sie sich bitte
        an unsere oben angegebene Kontaktadresse oder unseren
        Datenschutzbeauftragten.
      </p>

      <ul>
        <li>
          <p>
            Sie haben das Recht, von uns jederzeit auf Antrag eine Auskunft über
            die von uns verarbeiteten, Sie betreffenden personenbezogenen Daten
            im Umfang des Art.&nbsp;15&nbsp;DSGVO zu erhalten.
          </p>
        </li>
        <li>
          <p>
            Sie haben das Recht, von uns die unverzügliche Berichtigung der Sie
            betreffenden personenbezogenen Daten zu verlangen, sofern diese
            unrichtig sein sollten.
          </p>
        </li>
        <li>
          <p>
            Sie haben das Recht, unter den in Art.&nbsp;17&nbsp;DSGVO
            beschriebenen Voraussetzungen von uns die Löschung der Sie
            betreffenden personenbezogenen Daten zu verlangen. Diese
            Voraussetzungen sehen insbesondere ein Löschungsrecht vor, wenn die
            personenbezogenen Daten für die Zwecke, für die sie erhoben oder auf
            sonstige Weise verarbeitet wurden, nicht mehr notwendig sind, sowie
            in Fällen der unrechtmäßigen Verarbeitung, des Vorliegens eines
            Widerspruchs oder des Bestehens einer Löschungspflicht nach
            Unionsrecht oder dem Recht des Mitgliedstaates, dem wir unterliegen.
            Zum Zeitraum der Datenspeicherung verweisen wir auf Ziffer&nbsp;8
            dieser Datenschutzinformation.
          </p>
        </li>
        <li>
          <p>
            Sie haben das Recht, von uns die Einschränkung der Verarbeitung nach
            Maßgabe des Art.&nbsp;18&nbsp;DSGVO zu verlangen. Dieses Recht
            besteht insbesondere, wenn die Richtigkeit der personenbezogenen
            Daten zwischen Ihnen und uns umstritten ist, für die Dauer, welche
            die Überprüfung der Richtigkeit erfordert, sowie im Fall, dass Sie
            bei einem bestehenden Recht auf Löschung anstelle der Löschung eine
            eingeschränkte Verarbeitung verlangen; ferner für den Fall, dass die
            Daten für die von uns verfolgten Zwecke nicht länger erforderlich
            sind, Sie sie jedoch zur Geltendmachung, Ausübung oder Verteidigung
            von Rechtsansprüchen benötigen sowie, wenn die erfolgreiche Ausübung
            eines Widerspruchs zwischen uns und Ihnen noch umstritten ist.
          </p>
        </li>
        <li>
          <p>
            Sie haben das Recht, von uns die Sie betreffenden personenbezogenen
            Daten, die Sie uns bereitgestellt haben, in einem strukturierten,
            gängigen, maschinenlesbaren Format nach Maßgabe des
            Art.&nbsp;20&nbsp;DSGVO zu erhalten.
          </p>
        </li>
        <li>
          <p>
            Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen
            Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender
            personenbezogener Daten, die u.a. aufgrund von
            Art.&nbsp;6&nbsp;Abs.&nbsp;1&nbsp;S.&nbsp;1&nbsp;lit.&nbsp;f&nbsp;DSGVO
            erfolgt, Widerspruch nach Art.&nbsp;21&nbsp;DSGVO einzulegen. Wir
            werden die Verarbeitung Ihrer personenbezogenen Daten einstellen, es
            sei denn, wir können zwingende schutzwürdige Gründe für die
            Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten
            überwiegen, oder wenn die Verarbeitung der Geltendmachung, Ausübung
            oder Verteidigung von Rechtsansprüchen dient.
          </p>
        </li>
        <li>
          <p>
            Sie haben das Recht, sich bei Beschwerden wegen der durch den
            Verantwortlichen durchgeführten Datenverarbeitungen an die
            zuständige Aufsichtsbehörde zu wenden.
          </p>
        </li>
        <li>
          <p>
            Sofern die Verarbeitung von personenbezogenen Daten auf Grundlage
            Ihrer Einwilligung erfolgt, sind Sie nach Art.&nbsp;7&nbsp;DSGVO
            berechtigt, die Einwilligung in die Verwendung Ihrer
            personenbezogenen Daten jederzeit mit Wirkung für die Zukunft zu
            widerrufen, wobei der Widerruf ebenso einfach zu erklären ist, wie
            die Einwilligung. Bitte beachten Sie, dass der Widerruf erst für die
            Zukunft wirkt. Verarbeitungen, die vor dem Widerruf erfolgt sind,
            sind davon nicht betroffen.
          </p>
        </li>
      </ul>
    </>
  );
}

export { PrivacyStatement };
